export enum IconSizes {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export const iconSizeClasses: Record<IconSizes, string> = {
  [IconSizes.XS]: 'size-3',
  [IconSizes.SM]: 'size-4',
  [IconSizes.MD]: 'size-5',
  [IconSizes.LG]: 'size-6',
  [IconSizes.XL]: 'size-8',
};
